var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-table" },
    [
      _vm.loading
        ? _c("div", { staticClass: "loader-container" }, [
            _c("div", { staticClass: "loader" }),
          ])
        : _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c(
                "el-col",
                {
                  staticStyle: { "margin-bottom": "8px" },
                  attrs: { xs: 24, sm: 24, md: 24, lg: 14 },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "sizes, total, prev, pager, next",
                      "current-page": _vm.$currentPage,
                      "page-size": _vm.$pageSize,
                      "page-sizes": [10, 20, 30, 50, 100, 300, 500],
                      total: _vm.$totalData,
                    },
                    on: {
                      "size-change": function ($event) {
                        return _vm.handlePagination($event, "sizeChange")
                      },
                      "current-change": function ($event) {
                        return _vm.handlePagination($event, "currentChange")
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 24, lg: 10 } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("planning.refreshTable"),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "float-right",
                          attrs: { type: "info", size: "small" },
                          on: { click: _vm.$getUnassignedOrders },
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "sync" } }),
                          _c("font-awesome-icon", {
                            staticClass: "ml-1",
                            attrs: { icon: "columns" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.isViewOnly
                    ? _c("order-table-column-selector")
                    : _vm._e(),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("general.downloadExcel"),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "float-right",
                          staticStyle: { "margin-right": "8px" },
                          attrs: { type: "info", size: "small" },
                          on: { click: _vm.downloadExcel },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "file-excel", size: "sm" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("planning.toggleOrderFullscreen"),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "float-right",
                          staticStyle: { "margin-right": "8px" },
                          attrs: { type: "info", size: "small" },
                          on: { click: _vm.toggleOrderFullscreen },
                        },
                        [_c("fullscreen", { ref: "fullscreen" })],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.isChina
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("planning.showOrderOnMap"),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "float-right",
                              attrs: {
                                type: "info",
                                disabled: _vm.$selectedOrders.length === 0,
                                size: "small",
                              },
                              on: { click: _vm.showOrderOnMap },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "map-marked-alt", size: "sm" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$failedOrders.length > 0
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("planning.showFailedOrders"),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "float-right",
                              staticStyle: { "margin-right": "8px" },
                              attrs: { type: "info", size: "small" },
                              on: { click: _vm.showFailedOrders },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "parachute-box" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value:
                            _vm.$tableLoading ||
                            _vm.isManualAssignLoading ||
                            _vm.isAutoAssignLoading,
                          expression:
                            "$tableLoading || isManualAssignLoading || isAutoAssignLoading",
                        },
                      ],
                      ref: "unassignedOrderTable",
                      staticClass: "unassigned-table",
                      attrs: {
                        data: _vm.$unassignedOrders,
                        size: "mini",
                        height: _vm.tableHeight,
                        "row-class-name": _vm.tableRowClassName,
                        "default-sort": {
                          prop: "dropBuilding",
                          order: "descending",
                        },
                      },
                      on: {
                        "sort-change": _vm.handleSort,
                        select: _vm.selectClickHandler,
                        "select-all": _vm.selectAllHandler,
                        "row-click": _vm.rowClickHandler,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          selectable: _vm.isRowSelectable,
                          type: "selection",
                          width: "50",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          width: "50",
                          type: "index",
                          index: _vm.tableIndex,
                        },
                      }),
                      _c("el-table-column", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.isShowTableTooltip(scope.row)
                                  ? _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        !_vm.isOrderIdExistInGlobal(
                                          scope.row.id
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _vm.isShowTitle(scope.row)
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarningTitle"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason1"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning1"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason2"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning2"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason3"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning3"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason4"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning4"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason5"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning5"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason6"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning6"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason7"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning7"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason8"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning8"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason9"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning9"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason10"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning10"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                                _vm.isShowReason(
                                                  scope.row,
                                                  "reason11"
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "planning.tooltip.orderWarning11"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                        !_vm.isOrderIdExistInGlobal(
                                          scope.row.id
                                        )
                                          ? _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "exclamation-triangle",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.isOrderIdExistInGlobal(scope.row.id)
                                          ? _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.orderInUse"
                                                      )
                                                    )
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("general.usedBy")
                                                    ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.getGlobalOrderInfo(
                                                        scope.row.id,
                                                        "userName"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.isOrderIdExistInGlobal(scope.row.id)
                                          ? _c("font-awesome-icon", {
                                              attrs: { icon: "user" },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm.$defaultOrderColumns.length > 0
                        ? _vm._l(_vm.$selectedColumns, function (col, index) {
                            return _c("el-table-column", {
                              key: "" + col + index,
                              ref: col,
                              refInFor: true,
                              attrs: {
                                label: _vm.$t("planning.columns." + col),
                                "column-key": col,
                                prop: col,
                                width: _vm.helper.getColWidth(col),
                                sortable: _vm.isSortable(col)
                                  ? "custom"
                                  : false,
                                "show-overflow-tooltip":
                                  col === "pickBuilding" ||
                                  col === "pickCompName" ||
                                  col === "dropBuilding" ||
                                  col === "dropCompName",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm.isGenericStringColumns(col)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "unassigned-order-table",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row[col] || "-"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.isGenericNumberColumns(col)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "unassigned-order-table",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        scope.row[col] || 0
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          scope.row.waypoints,
                                          function (wp) {
                                            return _vm.isGenericWaypointColumns(
                                              col,
                                              wp.waypointType
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: wp.id,
                                                    staticClass:
                                                      "unassigned-order-table",
                                                  },
                                                  [
                                                    col === "pickDateTime" ||
                                                    col === "pickTimeWindow" ||
                                                    col === "dropDateTime" ||
                                                    col === "dropTimeWindow"
                                                      ? _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "convertTimezone"
                                                                )(
                                                                  wp.startTime,
                                                                  _vm.$timezone,
                                                                  "YY-MM-DD HH:mm"
                                                                )
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "convertTimezone"
                                                                )(
                                                                  wp.endTime,
                                                                  _vm.$timezone,
                                                                  "HH:mm"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    col === "pickDistrict" ||
                                                    col === "dropDistrict"
                                                      ? _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                !_vm.helper.isUndefined(
                                                                  wp.district
                                                                )
                                                                  ? wp.district
                                                                  : "-"
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    col === "pickBuilding" ||
                                                    col === "dropBuilding"
                                                      ? _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                !_vm.helper.isUndefined(
                                                                  wp.address1
                                                                )
                                                                  ? wp.address1
                                                                  : "-"
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    col === "pickCompName" ||
                                                    col === "dropCompName"
                                                      ? _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                !_vm.helper.isUndefined(
                                                                  wp.companyName
                                                                )
                                                                  ? wp.companyName
                                                                  : "-"
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    col === "pickPhoneNumber" ||
                                                    col === "dropPhoneNumber"
                                                      ? _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                !_vm.helper.isUndefined(
                                                                  wp.phone
                                                                )
                                                                  ? wp.phone
                                                                  : "-"
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        col === "itemInfo"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "unassigned-order-table",
                                              },
                                              [
                                                _vm.formatItemInfo(
                                                  scope.row.itemInfo
                                                ).length === 0
                                                  ? _c("div", [_vm._v("-")])
                                                  : _vm._l(
                                                      _vm.formatItemInfo(
                                                        scope.row.itemInfo
                                                      ),
                                                      function (item, index) {
                                                        return _c(
                                                          "div",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(item) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        col === "readyToShip"
                                          ? _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.readyToShip
                                                      ? "YES"
                                                      : "NO"
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }